import type { QuoteTracking, QuoteTrackingState } from "cadendar-shared";

export interface QuoteTrackingDraft {
  state: QuoteTrackingState;
  effectiveDate: string;
  deliveryDate: string;
  acceptanceDate: string;
  expectedHistoryLength: number;
  suggestedDeliveryDate: boolean;
  suggestedAcceptanceDate: boolean;
}

type DraftAction =
  | { type: "open"; tracking: QuoteTracking; today: string }
  | { type: "close" }
  | { type: "state"; value: QuoteTrackingState }
  | {
      type: "date";
      field: "effectiveDate" | "deliveryDate" | "acceptanceDate";
      value: string;
    };

export function quoteTrackingDraftReducer(
  draft: QuoteTrackingDraft | null,
  action: DraftAction,
) {
  if (action.type === "close") return null;
  if (action.type === "open") {
    return {
      state: action.tracking.state,
      effectiveDate: action.today,
      deliveryDate: action.tracking.deliveryDate ?? "",
      acceptanceDate: action.tracking.acceptanceDate ?? "",
      expectedHistoryLength: action.tracking.history.length,
      suggestedDeliveryDate: false,
      suggestedAcceptanceDate: false,
    };
  }
  if (!draft) return draft;
  if (action.type === "date") {
    return {
      ...draft,
      [action.field]: action.value,
      deliveryDate:
        action.field === "deliveryDate" ||
        (action.field === "effectiveDate" && draft.suggestedDeliveryDate)
          ? action.value
          : draft.deliveryDate,
      acceptanceDate:
        action.field === "acceptanceDate" ||
        (action.field === "effectiveDate" && draft.suggestedAcceptanceDate)
          ? action.value
          : draft.acceptanceDate,
      suggestedDeliveryDate:
        action.field === "deliveryDate" ? false : draft.suggestedDeliveryDate,
      suggestedAcceptanceDate:
        action.field === "acceptanceDate"
          ? false
          : draft.suggestedAcceptanceDate,
    };
  }
  const deliveryDate = draft.suggestedDeliveryDate ? "" : draft.deliveryDate;
  const acceptanceDate = draft.suggestedAcceptanceDate
    ? ""
    : draft.acceptanceDate;
  const suggestDelivery =
    !deliveryDate && (action.value === "given" || action.value === "accepted");
  const suggestAcceptance = !acceptanceDate && action.value === "accepted";
  return {
    ...draft,
    state: action.value,
    deliveryDate: suggestDelivery ? draft.effectiveDate : deliveryDate,
    acceptanceDate: suggestAcceptance ? draft.effectiveDate : acceptanceDate,
    suggestedDeliveryDate: suggestDelivery,
    suggestedAcceptanceDate: suggestAcceptance,
  };
}
